import { TEXTS } from "../../constants";
import { parsePipeList, parseBulletList } from "../../utils";
import { toTitleCase } from "../../../../../utils/text";
import { openSimplePracticeBooking } from "../../../../../utils/simplePractice";
import { useBookablePractitioners } from "../../../../../hooks/useBookablePractitioners";
import {
  HeroWrapper,
  HeroContent,
  ProfileContainer,
  ProfileAvatar,
  ProfileInfo,
  ProfileName,
  ProfileTitle,
  SpecialtiesLabel,
  SpecialtiesContainer,
  SpecialtyChip,
  ButtonConteiner,
  ProfileHourlyRate,
} from "./styles";
import CTAButton from "../../../../../ui/ctaButton";
import useFreeConsultationCheck from "../../../../../hooks/useFreeConsultationCheck";
import FreeConsultationDialog from "../../../../../components/FreeConsultationDialog";

const HeroSection = ({ practitionerData }) => {
  const {
    showDialog,
    cancelling,
    dismiss,
    cancelAndProceed,
  } = useFreeConsultationCheck();

  const getInitials = (name) => {
    return name
      .split(" ")
      .map((n) => n[0])
      .join("");
  };

  // The link itself is only issued after the visitor passes verification;
  // here we just need to know whether this practitioner is bookable at all.
  const { isBookable } = useBookablePractitioners();
  const bookingUrl = isBookable(practitionerData?.fullName);

  const handleBookConsultation = () => {
    openSimplePracticeBooking(practitionerData?.fullName);
  };

  return (
    <HeroWrapper>
      <HeroContent>
        <ProfileContainer>
          <ProfileAvatar
            src={practitionerData.avatar}
            alt={practitionerData.fullName}
            sx={
              practitionerData.avatarPosition
                ? { '& img': { objectPosition: practitionerData.avatarPosition } }
                : /lauren\s+welchner/i.test(practitionerData.fullName || '')
                ? { '& img': { objectPosition: 'center' } }
                : undefined
            }
          >
            {getInitials(practitionerData.fullName)}
          </ProfileAvatar>

          <ProfileInfo>
            <ProfileName component="h1">{practitionerData.fullName}</ProfileName>

            {practitionerData.title && (
              <ProfileTitle>
                {parseBulletList(practitionerData.title).join(" • ")}
              </ProfileTitle>
            )}

            {practitionerData.specialties && (
              <>
                <SpecialtiesLabel>
                  {TEXTS.hero.specialtiesLabel}
                </SpecialtiesLabel>
                <SpecialtiesContainer>
                  {parsePipeList(practitionerData.specialties).map(
                    (specialty, idx) => (
                      <SpecialtyChip key={idx} label={toTitleCase(specialty)} />
                    ),
                  )}
                </SpecialtiesContainer>
              </>
            )}

            {practitionerData.hourlyRate && (
              <ProfileHourlyRate>
                Hourly Rate: ${practitionerData.hourlyRate}
              </ProfileHourlyRate>
            )}
          </ProfileInfo>
        </ProfileContainer>
        {bookingUrl && (
          <ButtonConteiner>
            <CTAButton
              text={TEXTS.hero.bookConsultation}
              onClick={handleBookConsultation}
            />
          </ButtonConteiner>
        )}
      </HeroContent>

      <FreeConsultationDialog
        open={showDialog}
        cancelling={cancelling}
        onDismiss={dismiss}
        onCancelAndProceed={cancelAndProceed}
      />
    </HeroWrapper>
  );
};

export default HeroSection;
